import Alpine from 'alpinejs'
import persist from '@alpinejs/persist'

Alpine.plugin(persist)

const init = async (popup) => {
    if (popup.classList.contains('popup-onload')) {
        setTimeout(() => {
            popup.style.opacity = 1;
            popup.style.visibility = 'visible';
        }, 2000)
    }
}

export { init }
